import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/logo_with_subtitle.png")